import FlashcardsPicker from "src/components/NewComponents/Creator/ContentPicker/FlashcardsPicker";

import { LayoutWithSearch } from "src/containers/Layouts/LayoutWithSearch";

function FlashcardsContainer() {
	return (
		<LayoutWithSearch>
			<FlashcardsPicker />
		</LayoutWithSearch>
	);
}

export default FlashcardsContainer;
